let baseURL = '';

if (process.env.NODE_ENV !== 'production') {
  baseURL = 'http://acura.com/';
}

export const BASE_URL = baseURL;
export const VEHICLE_QUERY_PARAM = 'vehiclemodelseries';
export const ZIPCODE_QUERY_PARAM = 'zipcode';
export const OFFERID_QUERY_PARAM = 'offer';
export const TABID_QUERY_PARAM = 'tabid';
export const OFFER_MODELID_QUERY_PARAM = 'modelid';
export const OFFER_SORT_QUERY_PARAM = 'offer';
export const INTERPOLATION_REGEX = /\[%%[\d\D]*?%%]/g; // matches any text between delimiters
export const MEDIAQUERY_XSMALL = '(min-width: 319px) and (max-width: 549px)';
export const MEDIAQUERY_SMALL = '(min-width: 550px) and (max-width: 767px)';
export const MEDIAQUERY_MEDIUM = '(min-width: 768px) and (max-width: 1023px)';
export const MEDIAQUERY_LARGE = '(min-width: 1024px) and (max-width: 1399px)';
export const MEDIAQUERY_XLARGE = '(min-width: 1400px)';
export const DEALERID_QUERY_PARAM = 'dealerid';
